// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".lawyer_modify_picture_wrapper-module__container--De2-C{height:120px;width:120px;position:relative;cursor:pointer;margin:auto}.lawyer_modify_picture_wrapper-module__modify--1lloX{position:absolute;background-color:rgba(0,0,0,0.44);color:#fff;text-align:center;width:100%;height:100%;-webkit-border-radius:50%;-moz-border-radius:50%;border-radius:50%;top:0}.lawyer_modify_picture_wrapper-module__modifyText--6Rkm-{font-weight:500;font-size:16px;line-height:24px;letter-spacing:0px;position:absolute;top:45%;left:0;right:0}\n", ""]);
// Exports
exports.locals = {
	"container": "lawyer_modify_picture_wrapper-module__container--De2-C",
	"modify": "lawyer_modify_picture_wrapper-module__modify--1lloX",
	"modifyText": "lawyer_modify_picture_wrapper-module__modifyText--6Rkm-"
};
module.exports = exports;
